// removed by extract-text-webpack-plugin
module.exports = {"registerButton":"src-components-buttons-RegisterButton----register-button-module---registerButton---1GEPD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/RegisterButton/register-button.module.scss
// module id = 347
// module chunks = 168707334958949